import React from 'react';

export interface InventarioIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const InventarioIcon: React.FC<InventarioIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.653 4.916h2.083A2.083 2.083 0 0 1 21.82 7v14.583a2.083 2.083 0 0 1-2.084 2.083h-12.5a2.083 2.083 0 0 1-2.083-2.083V7a2.083 2.083 0 0 1 2.083-2.084H9.32m1.041-2.083h6.25c.575 0 1.042.466 1.042 1.042v2.083c0 .575-.466 1.042-1.042 1.042h-6.25A1.04 1.04 0 0 1 9.32 5.958V3.875c0-.576.467-1.042 1.042-1.042"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.505 11.164h6.302"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19.118 9.741-.978 1.619-.875-.461m1.853 2.891-.978 1.619-.875-.461m1.853 2.891-.978 1.618-.875-.46"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.505 15.111h6.302M8.505 19.15h6.302"/>
    </svg>
  );
};

export default InventarioIcon;
